import React, { Component } from 'react';
import PropTypes from 'prop-types';
import POIColorPicker from '../../UserControl/IconColorPicker/POIColorPicker.';
import moment from 'moment';
import { checkStatus } from '../../../../util/util';

let lat,lon;
class EditPOI extends Component {

    constructor(props) {
        super(props);

        this.state = {
            
            email: '',
            line_token: '',
            is_entry: false,
            is_leave: false,
            create_dtm: moment,
            create_user: '',
            group: '',
            icon_name: '', 
            icon_color: '', 
            icon_is_small: false,
            last_upd_dtm: '',
            last_upd_user: '',
            loc_type: '', 
            loc_coordinates0: '',
            loc_coordinates1: '',
            latitude: '', 
            longitude: '',
            name: '',
            poi_id: '',
            radius: '',
            user_id: '',
            _id: '',
            place:''
        };
    }

    componentWillMount(){
    }

    componentDidMount(){
    }

    componentWillReceiveProps(nextProps){
        console.log('componentWillReceiveProps')
        lat = this.props.lonlat[1];
        lon = this.props.lonlat[0];

        if (nextProps.dataPOI !== this.props.dataPOI ) {
            
            let poi = nextProps.dataPOI;

            this.setState({
                // email: poi.alert.email,
                // line_token: poi.alert.line_token,
                // is_entry: poi.alert.when.is_entry,
                // is_leave: poi.alert.when.is_leave,
                // create_dtm: poi.create_dtm,
                // create_user: poi.create_user,
                group: poi.group,
                icon_name: poi.icon.name?poi.icon.name:"", 
                icon_color: poi.icon.color?poi.icon.color:"", 
                icon_is_small: poi.icon.is_small,
                // last_upd_dtm: poi.last_upd_dtm,
                // last_upd_user: poi.last_upd_user,
                // loc_type: poi.loc.type, 
                // loc_coordinates0: poi.loc.coordinates[0],
                // loc_coordinates1: poi.loc.coordinates[1],
                // latitude: poi.location.latitude == undefined ? this.props.lonlat[1]: poi.location.latitude, 
                // longitude: poi.location.longitude == undefined ? this.props.lonlat[0]: poi.location.longitude,
                latitude: poi.location.latitude, 
                longitude: poi.location.longitude,  
                name: poi.name,
                poi_id: poi.poi_id,
                radius: poi.radius,
                user_id: poi.user_id,
                _id: poi._id
            }, () => {
                console.log('will getAddress')
                this.getAddressLocation();
            })
            

        }else{
            
            let lat = '';
            let lon = '';
            if(nextProps.lonlat.length > 0){
                lat = nextProps.lonlat[1];
                lon = nextProps.lonlat[0];
                this.setState({
                    latitude:lat, 
                    longitude: lon,
                }, () => {
                    console.log('will getAddress')
                    this.getAddressLocation();
                })
            }
            else if(this.props.lonlat.length > 0) {
                lat = this.props.lonlat[1];
                lon = this.props.lonlat[0];
                this.setState({
                    latitude:lat, 
                    longitude: lon,
                }, () => {
                    console.log('will getAddress')
                    this.getAddressLocation();
                })
            }
            
        }

        
    }

    onCheckIsEntry = (isEntrys) => {
        this.setState({ poiObj: { ...this.state.poiObj, isEntry: isEntrys } })
    }

    onCheckIsLeave = (isLeaves) => {
        this.setState({ poiObj: { ...this.state.poiObj, isLeave: isLeaves } })
    }

    setMarker(icon,color){
        this.setState({ icon_name:icon, icon_color:color } );
        console.log("setMarker",icon,color);
    }

    onClickBack = () => {
        const {onBack,dataPOI} = this.props;
        onBack(dataPOI.poi_id);
        if(this.props.onClickUpdatePOI && this.props.onClickUpdatePOI!=null)
            this.props.onClickUpdatePOI(false);
    }

    onDeleteClick = () => {
        const {onClickDeletePoi,dataPOI } = this.props;
        onClickDeletePoi(dataPOI.poi_id);
        
    }

    confirmAddPoi = () => {
        const {onClickConfirmAddPoi } = this.props;
        let data = {};
        const {
            
            group,
            icon_name, 
            icon_color, 
            icon_is_small,
            
            loc_type, 
            loc_coordinates0,
            loc_coordinates1,
            latitude, 
            longitude,
            name,
            poi_id,
            radius,
            user_id,
            _id
        } = this.state;

        let ck = false;
        data.group=group;
        data.icon_name= icon_name;
        data.icon_color= icon_color;
        data.icon_is_small=icon_is_small;
        
        data.loc_type= loc_type;
        data.loc_coordinates0=loc_coordinates0;
        data.loc_coordinates1=loc_coordinates1;
        data.latitude= latitude;
        data.longitude=longitude;
        data.name=name;
        data.poi_id=poi_id;
        data.radius=radius;
        data.user_id=user_id;

        if(data.name == '')
            ck = true;

        // if(data.group == '')
        //     ck = true;

        if(data.latitude == '')
            ck = true;
        
        if(data.longitude == '')
            ck = true;

        if(data.radius == '')
            ck = true;

        if(ck){
            alert("กรุณากรอกข้อมูลให้ครบถ้วน")
            return 0;
        }else{
            onClickConfirmAddPoi(data);
        }
        

    }

    confirmEditPoi = () => {
        const {onClickConfirmEditPoi } = this.props;
        let data = {};
        const {
            
            group,
            icon_name, 
            icon_color, 
            icon_is_small,
            
            loc_type, 
            loc_coordinates0,
            loc_coordinates1,
            latitude, 
            longitude,
            name,
            poi_id,
            radius,
            user_id,
            _id
        } = this.state;

        let ck = false;
        data.group=group;
        data.icon_name= icon_name;
        data.icon_color= icon_color;
        data.icon_is_small=icon_is_small;
        
        data.loc_type= loc_type;
        data.loc_coordinates0=loc_coordinates0;
        data.loc_coordinates1=loc_coordinates1;
        data.latitude= latitude;
        data.longitude=longitude;
        data.name=name;
        data.poi_id=poi_id;
        data.radius=radius;
        data.user_id=user_id;

        if(data.name == '')
            ck = true;

        // if(data.group == '')
        //     ck = true;

        if(data.latitude == '')
            ck = true;
        
        if(data.longitude == '')
            ck = true;

        if(data.radius == '')
            ck = true;

        if(ck){
            alert("กรุณากรอกข้อมูลให้ครบถ้วน")
            return 0;
        }else{
            onClickConfirmEditPoi(data);
        }
        
        

    }

    getAddressLocation = () =>{

        const { longitude,latitude} = this.state;
        
        console.log('getAddressLocation',longitude,latitude)
        console.log(longitude,latitude)

        const { user_id, user_name,token} = this.props;
        // 18649
        fetch(`http://203.150.199.244/api/realtime/getAddressLocation`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
                
            },
            body: JSON.stringify({
                "latitude":latitude,
	            "longitude":longitude
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {


                    this.setState({
                        
                        place:data.RESULT_DATA[0].address,
                        
                    });


            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

  render() {
      
      const { editPoiObj, onClickCancelEditPoi, onClickConfirmEditPoi, onClickDeletePoi,dataPOI ,ckAdd} = this.props;

      const { poiObj, name,icon_name,icon_color,loc_type } = this.state;

      console.log('lonlat state',this.state.latitude)
      console.log('lonlat state',this.state.longitude)
      console.log('lonlat',lat)
      console.log('lonlat',lon)

      console.log("toto tide",icon_name,icon_color)

    return (
        <div className="gray-panel" >
                   
                        
                                {
                                    ckAdd &&
                                    <strong>เพิ่ม POI</strong>
                                }
                                {
                                    !ckAdd &&
                                    <div>
                                        <strong> <i class="fa fa-arrow-left" aria-hidden="true" style={{color: '#7386D5',cursor: 'pointer'}} onClick={this.onClickBack}></i> รถที่อยู่ใกล้</strong>
                                        <hr/>
                                        <strong>แก้ไขข้อมูล POI</strong>
                                    </div>
                                   
                                }
                                
                                    {/* <button className="btn btn-danger pull-right" onClick={(e) => { e.preventDefault(); onClickDeletePoi(editPoiObj); }}  >ลบ</button> */}
                                <div className="form-group row">
                                <label className="col-md-4  col-form-label " >ชื่อ POI</label>
                                <div className="col-md-8">
                                    <input
                                        className="form-control"
                                        type="text"
                                        id="example-text-input"
                                        defaultValue={this.state.name}
                                        onChange={(e) => this.setState({ name : e.target.value })}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                            <label className="col-md-4  col-form-label " >กลุ่ม</label>
                                <div className="col-md-8">
                                    <input
                                        className="form-control"
                                        type="text"
                                        id="example-text-input"
                                        defaultValue={this.state.group}
                                        onChange={(e) => this.setState({group: e.target.value } )}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                            <label  className="col-md-4  col-form-label " >สถานที่</label>
                                <div className="col-md-8">
                                <label className=" col-form-label "> {this.state.place}</label>
                                </div>
                            </div>
                            <div className="form-group row">
                            <label className="col-md-4  col-form-label " >รัศมี (เมตร)</label>
                                <div className="col-md-8">
                                    <input
                                        className="form-control"
                                        type="text"
                                        id="example-text-input"
                                        defaultValue={this.state.radius}
                                        onChange={(e) => this.setState({  radius: e.target.value } )}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                            <label className="col-md-4  col-form-label " >latitude</label>
                                <div className="col-md-8">
                                    <input
                                        className="form-control"
                                        type="text"
                                        id="example-text-input"
                                        defaultValue={this.state.latitude}
                                        onChange={(e) => this.setState({ latitude: e.target.value })}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                            <label className="col-md-4  col-form-label " >longitude</label>
                                <div className="col-md-8">
                                    <input
                                        className="form-control"
                                        type="text"
                                        id="example-text-input"
                                        defaultValue={this.state.longitude}
                                        onChange={(e) => this.setState({ longitude: e.target.value })}
                                    />
                                </div>
                            </div>
                            <hr />
                            {
                                icon_name != undefined ?
                                <POIColorPicker onIconColorSelected={this.setMarker.bind(this)} defaultIcon={icon_name} defaultColor={icon_color} openAlway />
                                :null
                            }
                            
                            <div className="text-right">
                        
                                {
                                    ckAdd &&
                                    <button className="btn btn-primary" style={{marginTop:3}} onClick={this.confirmAddPoi}>บันทึกข้อมูล</button>
                                }
                                
                                
                                {
                                    !ckAdd && 
                                    <div>
                                    <button className="btn btn-primary" style={{marginTop:3}} onClick={this.confirmEditPoi}>บันทึกข้อมูล</button>
                                    &nbsp;&nbsp;&nbsp;
                                    <input type="button" className="btn btn-danger" style={{marginTop:3}} value="ลบ"  onClick={this.onDeleteClick} />
                                    </div>
                                    
                                }
                                
                            </div>
        </div>
    );
  }
}

EditPOI.propTypes = {
    // editPoiObj: PropTypes.object.isRequired,
    onClickCancelEditPoi: PropTypes.func.isRequired,
    onClickConfirmEditPoi: PropTypes.func.isRequired,
    onClickConfirmAddPoi: PropTypes.func.isRequired,
    onClickDeletePoi: PropTypes.func.isRequired,
    onBack:PropTypes.func,
    token: PropTypes.string.isRequired,
    dataPOI:PropTypes.object,
    ckAdd:PropTypes.bool,
    lonlat:PropTypes.array
}

export default EditPOI;



// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/POI/EditPOI.js